import { render } from "./ActionField.vue?vue&type=template&id=3bef2f16&scoped=true"
import script from "./ActionField.vue?vue&type=script&lang=js"
export * from "./ActionField.vue?vue&type=script&lang=js"

import "./ActionField.vue?vue&type=style&index=0&id=3bef2f16&lang=scss&scoped=true"

import exportComponent from "/Users/shuaqq/Desktop/quickadmin/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bef2f16"]])

export default __exports__